module.exports = __webpack_public_path__ + "img/28.43b406c7.svg";